
export default [{
    title: 'contabilidad.menu_title',
    fontIcon: 'calculator',
    resource: 'Contabilidad',
    action: 'ver-contabilidad',
    children: [
        {
            title: 'global.menu.transacciones',
            fontIcon: 'exchange-alt',
            resource: 'Contabilidad',
            action: 'ver-contabilidad-transacciones',
            children: [
                {
                    route: 'contabilidad-cierre-contable',
                    title: 'contabilidad.transacciones.cierre_contable.menu_title',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-transacciones-cierre-contable',
                },
                {
                    route: 'contabilidad-transacciones-transacciones-contables',
                    title: 'contabilidad.transacciones.transaccion_contable.menu_title',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-transacciones-transacciones-contables',
                },
                {
                    title: 'contabilidad.transacciones.exportar_diarios.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informe-reporte-export-diario',
                    route: 'contabilidad-informe-reporte-export-diario',
                },
                {
                    title: 'contabilidad.transacciones.importar_diarios.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informe-reporte-importar-diario',
                    route: 'contabilidad-informe-reporte-importar-diario',
                },
            ],
        },

        {
            title: 'Configuracion',
            icon: 'SettingsIcon',
            resource: 'Contabilidad',
            action: 'ver-contabilidad-configuracion',
            children: [
                {
                    route: 'contabilidad-configuracion-crear-plan-cuenta',
                    title: 'contabilidad.configuracion.crear_plan_cuenta.menu_title',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-configuracion-crear-plan-cuenta',
                },
                {
                    route: 'contabilidad-configuracion-diario-apertura',
                    title: 'contabilidad.configuracion.diario_apertura.menu_title',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-configuracion-diario-apertura',
                },
                {
                    route: 'contabilidad-configuracion-estado-plan-cuenta',
                    title: 'contabilidad.configuracion.cuentas_contables.estado_plan_cuenta',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-configuracion-estado-plan-cuenta',
                },
                {
                    route: 'contabilidad-configuracion-maestro-clase-cuenta',
                    title: 'contabilidad.configuracion.clase_cuenta.menu_title',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-configuracion-maestro-clase-cuenta',
                },
                {
                    route: 'contabilidad-maestro-plan-cuenta',
                    title: 'contabilidad.configuracion.cuentas_contables.menu_title',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-maestro-plan-cuenta',
                },
                {
                    route: 'contabilidad-configuracion-permisos',
                    title: 'Permisos',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-configuracion-permisos',
                },

            ],
        },
        {
            title: 'Informes',
            fontIcon: 'file-prescription',
            resource: 'Contabilidad',
            action: 'ver-contabilidad-informes',
            children: [
                {
                    title: 'contabilidad.informes.anexos.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-anexos',
                    route: 'contabilidad-informes-anexos',
                },
                {
                    title: 'contabilidad.informes.balance_comprobacion.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-balance-comprobacion',
                    route: 'contabilidad-informes-balance-comprobacion',

                },
                {
                    title: 'contabilidad.informes.balance_general.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-balance-general',
                    route: 'contabilidad-informes-balance-general',
                },
                {
                    title: 'Desempeño Contable',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-reporte-desempeno-contable',
                    route: 'contabilidad-informes-reporte-desempeno-contable',

                },
                {
                    title: 'contabilidad.informes.diario_general.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-diario-general',
                    route: 'contabilidad-informes-diario-general',
                },
                {
                    title: 'contabilidad.informes.estado_pyg.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-estado-pyg',
                    route: 'contabilidad-informes-estado-pyg',

                },
                {
                    title: 'contabilidad.informes.mayor_general.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-mayor-general',
                    route: 'contabilidad-informes-mayor-general',
                },
                {
                    title: 'contabilidad.informes.plan_cuenta.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-reporte-plan-cuenta',
                    route: 'contabilidad-informes-reporte-plan-cuenta',
                },
                {
                    title: 'contabilidad.informes.plan_cuenta_niif.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-reporte-plan-cuenta-niif',
                    route: 'contabilidad-informes-reporte-plan-cuenta-niif',
                },
                {
                    title: 'contabilidad.informes.plan_cuenta_cias.menu_title',
                    fontIcon: 'sitemap',
                    resource: 'Contabilidad',
                    action: 'ver-contabilidad-informes-reporte-plan-cuenta-cias',
                    route: 'contabilidad-informes-reporte-plan-cuenta-cias',
                },
            ],
        },
        {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Contabilidad",
            action: "ver-contabilidad-mantenimiento",
            children: [
                {
                    route: "contabilidad-mantenimiento-codigo-transaccion",
                    title: "Codigo Transacción",
                    resource: "Contabilidad",
                    action: "ver-contabilidad-mantenimiento-codigo-transaccion",
                },
                {
                    route: "contabilidad-mantenimiento-grupo-movimiento",
                    title: "Grupo Movimiento",
                    resource: "Contabilidad",
                    action: "ver-contabilidad-mantenimiento-grupo-movimiento",
                },
                {
                    route: "contabilidad-mantenimiento-proceso",
                    title: "Proceso",
                    resource: "Contabilidad",
                    action: "ver-contabilidad-mantenimiento-proceso",
                },
            ],
        },
    ],
}]
